import { Button, DynamicFormModal } from '@insurancemenu/imenu-components-lib/dist/components';
import { breakpointsMQ4 } from '@insurancemenu/imenu-components-lib/dist/utils/breakpoints';
import styled from 'styled-components';

export const AddDependentButtonStyled = styled(Button)`
  margin: 0 auto 6rem;
`;

export const DynamicFormModalStyled = styled(DynamicFormModal)`
  max-width: 90rem;

  ${breakpointsMQ4.md.down} {
    max-width: 65%;
  }
`;
